import * as React from "react";
import * as _ from 'lodash';
import User from "../../_data/models/User";

interface Props {
    selectedType: string;
    secondaryFilters: string[];
    changeFilterType: (type: string) => void;
    toggleSecondaryFilter: (e: React.FormEvent<HTMLInputElement>) => void;
    currentUser: User;
}

const typeFiltersWithoutBooth = {
    style: 'Images',
    salon: 'Shops',
    user: 'Users',
    special: 'Specials'
};


const typeFilters = {
    ...typeFiltersWithoutBooth,
    booth: 'Booths For Rent',
};


const imageFilters = {
    professional: 'From Professionals',
    user: 'From Users'
};

const shopFilters = [
    'Barbershop',
    'Salon',
    'Unisex',
    'Spa',
    'Nails',
    'Tattoo'
];

export const professionalFilter = [
    'Non Professional',
    'Barber',
    'Hairstylist',
    'Nail Technician',
    'Esthetician',
    'Make Up Artist',
    'Tattoo Artist',
    'Other'
];

const SearchFiltersComponent = (props: Props) => {
    const {selectedType, secondaryFilters, changeFilterType, toggleSecondaryFilter, currentUser} = props;

    return (
        <div id="searchFilters" className="row p1" style={{display: 'block'}}>
            <fieldset className="large-6 columns">
                <legend>Filter Your Search</legend>
                {Object.keys(currentUser && currentUser.isProfessional ? typeFilters : typeFiltersWithoutBooth).map(t => {
                    return (
                        <span key={t}>
                            <input type="radio" checked={selectedType == t} onClick={() => changeFilterType(t)}/>
                            <label>{typeFilters[t]}</label>
                        </span>
                    )
                })}
            </fieldset>
            {_.includes(['style', 'salon', 'user'], selectedType) &&
            <fieldset className="large-6 columns">
                <legend>Check these out</legend>
                {selectedType == 'style' && Object.keys(imageFilters).map(f => {
                    return <CheckBoxFilter label={imageFilters[f]} value={f} currentFilters={secondaryFilters}
                                           onChange={toggleSecondaryFilter} key={f}/>
                })}

                {selectedType == 'salon' && shopFilters.map(f => {
                    return <CheckBoxFilter label={f} value={f} currentFilters={secondaryFilters}
                                           onChange={toggleSecondaryFilter} key={f}/>
                })}

                {selectedType == 'user' && professionalFilter.map(f => {
                    return <CheckBoxFilter label={f} value={f} currentFilters={secondaryFilters}
                                           onChange={toggleSecondaryFilter} key={f}/>
                })}
            </fieldset>
            }
        </div>

    );
};

interface CheckBoxFilterProps {
    label: string;
    currentFilters: string[];
    value: string;
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const CheckBoxFilter = (props: CheckBoxFilterProps) => {
    const {label, value, currentFilters, onChange} = props;

    return (
        <span>
            <input type="checkbox" value={value} checked={_.includes(currentFilters, value)} onChange={onChange}/>
            <label>{label}</label>
        </span>
    );
}

export default SearchFiltersComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchFiltersComponent.tsx